import styled from '@emotion/styled'
import { useTranslation } from 'react-i18next'

import type {
  MatchFieldsFragment as MatchData,
  PendingMatchFieldsFragment as PendingMatchData
} from 'src/graphql/types'
import { PendingMatchStatus } from 'src/graphql/types'
import { MatchLifecycle } from 'src/screens/matches/collection/MatchLifecycle'

export function MatchesGrid(props: {
  matches: (PendingMatchData | MatchData)[]
}) {
  const { t } = useTranslation()
  const allMatches = props.matches ?? []

  const validMatches: (PendingMatchData | MatchData)[] = []
  let duplicateCount = 0
  const seenErrorCodes = new Set<string>()

  for (const match of allMatches) {
    if (
      'status' in match &&
      match.status === PendingMatchStatus.Failed &&
      match.errorCode
    ) {
      if (seenErrorCodes.has(match.errorCode)) {
        duplicateCount++
        continue
      }
      seenErrorCodes.add(match.errorCode)
    }
    validMatches.push(match)
  }

  const duplicateKey =
    duplicateCount === 1
      ? 'matches:hidden_duplicates'
      : 'matches:hidden_duplicates_plural'

  return (
    <>
      {duplicateCount > 0 && (
        <ErrorSummary>
          {t(duplicateKey, { count: duplicateCount })}
        </ErrorSummary>
      )}
      <Box>
        {validMatches.map((match) => (
          <MatchLifecycle key={match.id} source={match} />
        ))}
      </Box>
    </>
  )
}

const Box = styled.div`
  display: grid;
  grid-template-columns: auto;
  grid-template-rows: auto;
  grid-gap: ${(props) => props.theme.d.spacing[4]};

  @media (min-width: ${(props) => props.theme.d.breakpoints.sm}) {
    grid-template-columns: auto auto;
    grid-template-rows: auto auto;
  }

  @media (min-width: ${(props) => props.theme.d.breakpoints.md}) {
    grid-template-columns: auto auto auto;
    grid-template-rows: auto auto auto;
  }
`

const ErrorSummary = styled.div`
  margin-top: ${(props) => props.theme.d.spacing[3]};
  font-size: 0.875rem;
  color: ${(props) => props.theme.d.colors.text.primary};
`
